import { useState } from "react";
import "./AppSettings.scss";
import Zoom from "@mui/material/Zoom";
import Tooltip from "@mui/material/Tooltip";
import NavSettings from "../NavSettings";
import ColorSettings from "../ColorSettings";
import TemplateSettings from "../TemplateSettings";
import IconsSettings from "../IconsSettings";
import PageSettings from "../page settings/PageSettings";
import LoaderSetting from "../../admin/LoaderSetting";
import ThemePalette from "../ThemePalette";
import LoginImageSetting from "../LoginImageSetting";
import MultiLocationSetting from "../MultiLocationSetting";
import ControlProductDetails from "../ControlProductDetails";
import TaxesSettings from "../TaxesSettings";
import FunctionsSettings from "../FunctionsSettings";
import { useDocument } from "../../../firebase-files/hooks/useDocument";

const AppSettingNew = () => {
  const { document: appTypeDoc } = useDocument("settings", "AppType");

  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("Product Details");

  const handleMenuClick = (menu) => {
    setSelectedMenu(menu);
  };

  const toggleMenu = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="app-setting-wrapper">
      <div className={`app-setting-sidebar ${isExpanded ? "expanded" : ""}`}>
        <div className="app-setting-top">
          <button className="app-setting-toggle-btn" onClick={toggleMenu}>
            <span className="material-symbols-outlined">menu</span>
          </button>
        </div>
        <div className="app-setting-menu">
          <Tooltip
            title="Product Details"
            TransitionComponent={Zoom}
            arrow
            placement="right"
          >
            <div
              className="app-setting-menu-item"
              onClick={() => handleMenuClick("Product Details")}
            >
              <span class="material-symbols-outlined">package_2</span>
              {isExpanded && <span>Product Details</span>}
            </div>
          </Tooltip>

          {appTypeDoc && appTypeDoc.apptype !== "lite" && (
            <Tooltip
              title="Templates"
              TransitionComponent={Zoom}
              arrow
              placement="right"
            >
              <div
                className="app-setting-menu-item"
                onClick={() => handleMenuClick("Templates")}
              >
                <span className="material-symbols-outlined">view_carousel</span>
                {isExpanded && <span>Templates</span>}
              </div>
            </Tooltip>
          )}
          {appTypeDoc && appTypeDoc.apptype !== "lite" && (
            <Tooltip
              title="Loaders"
              TransitionComponent={Zoom}
              arrow
              placement="right"
            >
              <div
                className="app-setting-menu-item"
                onClick={() => handleMenuClick("Loaders")}
              >
                <span className="material-symbols-outlined">hourglass_top</span>
                {isExpanded && <span>Loaders</span>}
              </div>
            </Tooltip>
          )}

          <Tooltip
            title="Page Control"
            TransitionComponent={Zoom}
            arrow
            placement="right"
          >
            <div
              className="app-setting-menu-item"
              onClick={() => handleMenuClick("Page Control")}
            >
              <span className="material-symbols-outlined">tune</span>
              {isExpanded && <span>Page Control</span>}
            </div>
          </Tooltip>

          {appTypeDoc && appTypeDoc.apptype !== "lite" && (
            <Tooltip
              title="Navigation Bar"
              TransitionComponent={Zoom}
              arrow
              placement="right"
            >
              <div
                className="app-setting-menu-item"
                onClick={() => handleMenuClick("Navbar")}
              >
                <span className="material-symbols-outlined">view_stream</span>
                {isExpanded && <span>Navigation Bar</span>}
              </div>
            </Tooltip>
          )}

          {appTypeDoc && appTypeDoc.apptype !== "lite" && (
            <Tooltip
              title="Change Colors"
              TransitionComponent={Zoom}
              arrow
              placement="right"
            >
              <div
                className="app-setting-menu-item"
                onClick={() => handleMenuClick("Change Colors")}
              >
                <span className="material-symbols-outlined">palette</span>
                {isExpanded && <span>Change Colors</span>}
              </div>
            </Tooltip>
          )}

          {appTypeDoc && appTypeDoc.apptype !== "lite" && (
            <Tooltip
              title="Themes"
              TransitionComponent={Zoom}
              arrow
              placement="right"
            >
              <div
                className="app-setting-menu-item"
                onClick={() => handleMenuClick("Themes")}
              >
                <span className="material-symbols-outlined">format_paint</span>
                {isExpanded && <span>Themes</span>}
              </div>
            </Tooltip>
          )}

          <Tooltip
            title="Login Images"
            TransitionComponent={Zoom}
            arrow
            placement="right"
          >
            <div
              className="app-setting-menu-item"
              onClick={() => handleMenuClick("Login Images")}
            >
              <span className="material-symbols-outlined">image</span>
              {isExpanded && <span>Login Images</span>}
            </div>
          </Tooltip>

          <Tooltip
            title="Floating Icons"
            TransitionComponent={Zoom}
            arrow
            placement="right"
          >
            <div
              className="app-setting-menu-item"
              onClick={() => handleMenuClick("Floating Icons")}
            >
              <span className="material-symbols-outlined">bubble_chart</span>
              {isExpanded && <span>Floating Icons</span>}
            </div>
          </Tooltip>

          {appTypeDoc && appTypeDoc.apptype !== "lite" && (
            <Tooltip
              title="Multi Location"
              TransitionComponent={Zoom}
              arrow
              placement="right"
            >
              <div
                className="app-setting-menu-item"
                onClick={() => handleMenuClick("Multi Location")}
              >
                <span className="material-symbols-outlined">location_on</span>
                {isExpanded && <span>Multi Location</span>}
              </div>
            </Tooltip>
          )}

          <Tooltip
            title="GST Tax"
            TransitionComponent={Zoom}
            arrow
            placement="right"
          >
            <div
              className="app-setting-menu-item"
              onClick={() => handleMenuClick("gst")}
            >
              <span className="material-symbols-outlined">receipt</span>
              {isExpanded && <span>Taxes</span>}
            </div>
          </Tooltip>

          <Tooltip
            title="Email Functions"
            TransitionComponent={Zoom}
            arrow
            placement="right"
          >
            <div
              className="app-setting-menu-item"
              onClick={() => handleMenuClick("functions")}
            >
              <span className="material-symbols-outlined">step_over</span>
              {isExpanded && <span>Functions</span>}
            </div>
          </Tooltip>
        </div>
      </div>

      <div className="app-setting-content">
        {selectedMenu === "Product Details" && <ControlProductDetails />}
        {selectedMenu === "Templates" && <TemplateSettings />}
        {selectedMenu === "Loaders" && <LoaderSetting />}
        {selectedMenu === "Floating Icons" && <IconsSettings />}
        {selectedMenu === "Page Control" && <PageSettings />}
        {selectedMenu === "Navbar" && <NavSettings />}
        {selectedMenu === "Change Colors" && <ColorSettings />}
        {selectedMenu === "Themes" && <ThemePalette />}
        {selectedMenu === "Login Images" && <LoginImageSetting />}
        {selectedMenu === "Multi Location" && <MultiLocationSetting />}
        {selectedMenu === "gst" && <TaxesSettings />}
        {selectedMenu === "functions" && <FunctionsSettings />}
      </div>
    </div>
  );
};

export default AppSettingNew;
